// 判断是否能滚动
export function hasScrollbar() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
}
export var commonVideoAttr = {
  'x5-video-player-type': 'h5',
  'x5-video-player-fullscreen': false,
  'x5-video-orientation': 'portrait',
  'x-webkit-airplay': 'allow',
  'webkit-playsinline': true,
  playsinline: true,
  controlslist: 'nofullscreen nodownload noremote footbar',
  muted: true,
  preload: true
};
export var getVideoImage = function getVideoImage(src) {
  var fallbackCover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/fission/upload-success.png';
  return new Promise(function (resolve) {
    // 如果低端机就直接兜底图
    var video = document.createElement('video');
    video.src = src;
    video.crossOrigin = 'anonymous';
    video.load(); // video.setAttribute('crossOrigin', 'Anonymous');

    video.addEventListener('loadeddata', function () {
      this.currentTime = 1;
    });
    video.addEventListener('error', function () {
      resolve({
        url: fallbackCover
      });
    });
    video.addEventListener('seeked', function () {
      this.width = this.videoWidth;
      this.height = this.videoHeight;
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = this.width;
      canvas.height = this.height;

      if (context) {
        context.drawImage(this, 0, 0, canvas.width, canvas.height);
        var image = {
          url: canvas.toDataURL('image/jpeg', 1),
          width: this.width,
          height: this.height,
          currentTime: this.currentTime,
          duration: this.duration
        };
        canvas.toBlob(function (blob) {
          image.blob = blob;
          resolve(image);
        }, 'image/jpeg');
      } else {
        resolve({
          url: fallbackCover
        });
      }
    });
  });
};
export var scrollToTop = function scrollToTop() {
  try {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } catch (error) {
    window.scrollTo(0, 0);
  }
};
export function getElementTop(el) {
  if (el.offsetParent) {
    return getElementTop(el.offsetParent) + el.offsetTop;
  }

  return el.offsetTop;
}